module.exports = __webpack_public_path__ + "img/heart_red.062bd8dc.svg";